<template>
  <v-btn
    title="show"
    color="agency-color-primary"
    class="white--text"
    fab
    small
    depressed
    link
    target="_blank"
    :href="documentUrl"
  >
    <v-icon>mdi-eye</v-icon>
  </v-btn>
</template>
<script>
export default {
  name: 'ShowDocumentButtonComponent',
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    //
  }),
  computed: {
    documentUrl () {
      return (
        '/file/' + this.id
      )
    }
  },
  created () {
    //
  },
  methods: {
    //
  }
}
</script>
<style lang='scss'>
    #showDocumentButtonComponent {
        //
    }
</style>
